if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.init = this.init.bind(this);
      // Init dupa ce DOM-ul + product-form (re-randat de Shopify la variant init) s-au asezat.
      if (document.readyState === 'complete') {
        this.init();
      } else {
        window.addEventListener('load', this.init, { once: true });
      }
    }

    init() {
      // Panelul e re-parentat la <main id="main-content">, deci closest poate da null -> fallback global.
      this.productSection = this.closest('.cc-main-product') || document.querySelector('.cc-main-product');
      this.productInfo = this.productSection?.querySelector('.product-info');
      this.productForm = this.productSection?.querySelector('product-form');
      this.addButton = this.productForm?.querySelector('[name="add"]');

      // Butonul sticky "Adauga in cos" declanseaza ATC-ul real (AJAX + drawer).
      this.stickyAddBtn = this.querySelector('[data-sticky-atc-add]');
      if (this.stickyAddBtn) {
        this.stickyAddBtn.addEventListener('click', () => {
          if (this.addButton && !this.addButton.disabled) {
            // Feedback imediat + confirmare pe butonul sticky
            const _orig = this.stickyAddBtn.dataset.addLabel || this.stickyAddBtn.textContent.trim();
            const _added = this.stickyAddBtn.dataset.addedLabel || _orig;
            let _done = false;
            this.stickyAddBtn.classList.add('is-loading');
            this.stickyAddBtn.setAttribute('aria-busy', 'true');
            const _success = () => {
              if (_done) return; _done = true;
              this.stickyAddBtn.classList.remove('is-loading');
              this.stickyAddBtn.removeAttribute('aria-busy');
              this.stickyAddBtn.classList.add('is-added');
              this.stickyAddBtn.textContent = _added + ' \u2713';
              setTimeout(() => {
                this.stickyAddBtn.classList.remove('is-added');
                this.stickyAddBtn.textContent = _orig;
              }, 1800);
            };
            const _mo = new MutationObserver(() => {
              if (!this.addButton.classList.contains('is-loading')) { _success(); _mo.disconnect(); }
            });
            _mo.observe(this.addButton, { attributes: true, attributeFilter: ['class'] });
            setTimeout(() => { if (!_done) { this.stickyAddBtn.classList.remove('is-loading'); this.stickyAddBtn.removeAttribute('aria-busy'); } try { _mo.disconnect(); } catch (e) {} }, 6000);
            this.addButton.click();
          } else if (this.productSection) {
            this.productSection.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }

      // FIX sticky: scoate garda 'invisible' (pre-JS) ca --out sa controleze vizibilitatea
      this.classList.remove('invisible');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      document.documentElement.classList.remove('sticky-atc-visible');
    }

    // Sincronizeaza o clasa pe <html> cand bara e vizibila, ca sa ridicam launcher-ele plutitoare (Smile.io etc.)
    syncWidgetOffset() {
      document.documentElement.classList.toggle(
        'sticky-atc-visible',
        !this.classList.contains('sticky-atc-panel--out')
      );
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
        this.syncWidgetOffset();
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
